// extracted by mini-css-extract-plugin
export default {"wrapper":"log_wrapper__26FkR","status":"log_status__i58eb"};